<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <sl-amap style="height:100%;">
      <sl-amap-marker ref="marker"></sl-amap-marker>
    </sl-amap>
    <!-- <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div> -->
  </sl-side-panel>
</template>
<script>
import { wgs2gcj, gcj2wgs } from '@/util/map/proj'
export default {
  components: {},
  data() {
    return {
      id: null,
      modalVisible: false,
      loading: false,
      // itemTitle必须有值，当第一次点击数据为空时，就不会显示头和关闭，一定要有默认值
      itemTitle: '详情',
      form: {},
    }
  },

  created() {},

  computed: {},
  watch: {},

  methods: {

    init(row) {
      this.itemTitle = '报警位置'
      this.show()
      this.form = row
      this.addMarker()
    },
    addMarker() {
      let tem = this.form
      if (tem.longitude && tem.latitude) {
        let point = wgs2gcj(...[tem.longitude, tem.latitude])
        this.$refs['marker'].addMarker(point)
      }
    },
    show() {
      this.modalVisible = true
    },
    hide() {
      this.modalVisible = false
    },
  }
}

</script>
<style scoped lang="less">
.imgs {
  width: 100px;
  display: inline-block;
  padding: 10px;
  cursor: pointer;
  vertical-align: top;
}

</style>
